<template>
  <input
    :type="type"
    :name="name"
    :maxlength="maxlength"
    :min="min"
    :placeholder="placeholder"
    :value="value"
    autocomplete="off"
    :disabled="disabled"
    class="c-input"
    @compositionstart="compositionstart"
    @compositionend="compositionend"
    @focusout="focusout"
    @keydown="keydown"
    @keypress="keypress"
    @keyup="keyup"
    @input="input"
  />
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    maxlength: {
      type: [Number, String],
      required: false
    },
    min: {
      type: Number,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: '入力してください'
    },
    required: {
      type: Boolean,
      required: false
    },
    trim: {
      type: Boolean,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    value: {
      type: [Number, String],
      required: false
    }
  },
  data() {
    return {
      key: {
        enter: 13
      },
      status: {
        ime: false,
        keydown: false,
        keypress: false
      }
    };
  },
  methods: {
    compositionstart() {
      this.status.ime = true;
    },
    compositionend() {
      this.status.ime = false;
    },
    focusout(e) {
      let value = e.target.value;
      if (this.trim) {
        value = value.trim();
        e.target.value = value;
      }
      this.$emit('input', value);
      this.$emit('focusout', e);
    },
    keydown() {
      this.status.keydown = true;
    },
    keypress() {
      this.status.keypress = true;
    },
    keyup(e) {
      // 日本語変換中はreturn
      if (this.status.ime) {
        return;
      }
      switch (e.keyCode) {
        case this.key.enter:
          // 日本語変換確定時のEnter以外のEnterで、enterイベントを発火させる
          if (this.status.keydown && this.status.keypress) {
            this.$emit('enter', e);
          }
          this.status.keydown = false;
          this.status.keypress = false;
          break;

        default:
          break;
      }
    },
    input(e) {
      let value = e.target.value;
      if (this.trim) {
        value = value.trim();
      }
      this.$emit('input', value);
    }
  }
};
</script>
